import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';
import type { Nft } from '@/ui/types';
import useWalletAccount from './use-wallet-account.js';

const useNft = ({ id }: { id: string }): { data?: Nft } => {
  const walletAccount = useWalletAccount();
  const getNft = useSelector(selectors.nfts.get);
  const nft = getNft({ id, walletAccount });

  return { data: nft };
};

export default useNft;
